// extracted by mini-css-extract-plugin
var _1 = "NewMobileBanner_bannerContainer__JMYAp";
var _2 = "NewMobileBanner_buttonContainer__JYft8";
var _3 = "NewMobileBanner_closeNewMobileBannerText__S7WPW";
var _4 = "NewMobileBanner_container__tfgPJ";
var _5 = "NewMobileBanner_description__nu15p";
var _6 = "NewMobileBanner_headerContainer__EntJB";
var _7 = "NewMobileBanner_logoImage__krmGf";
var _8 = "NewMobileBanner_mobileImageContainer__Er1O3";
var _9 = "NewMobileBanner_openButton__ijK+K";
var _a = "NewMobileBanner_textContainer__gtbGw";
var _b = "NewMobileBanner_title__Iv7Vq";
export { _1 as "bannerContainer", _2 as "buttonContainer", _3 as "closeNewMobileBannerText", _4 as "container", _5 as "description", _6 as "headerContainer", _7 as "logoImage", _8 as "mobileImageContainer", _9 as "openButton", _a as "textContainer", _b as "title" }
